<template>
  <div id="ylAboutCompanyProfile">
    <ylAboutCompanyProfileMobile v-if="isMobileScreen" v-bind="$attrs" />
    <ylAboutCompanyProfilePC v-else v-bind="$attrs" />
  </div>
</template>
<script>
export default {
  name: "ylAboutCompanyProfile",
  components: {
    ylAboutCompanyProfileMobile: () => import("./components/mobile.vue"),
    ylAboutCompanyProfilePC: () => import("./components/pc.vue"),
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
};
</script>